import { render, staticRenderFns } from "./RemindPassword.vue?vue&type=template&id=1b87d9ff&"
import script from "./RemindPassword.js?vue&type=script&lang=js&"
export * from "./RemindPassword.js?vue&type=script&lang=js&"
import style0 from "./RemindPassword.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports